import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind klašu apvienošana ar konfliktu atrisināšanu. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
